import {Component, OnInit} from '@angular/core';
import {HttpItemsService} from '../../services/http/http-items.service';
import {FilterHandlerService} from '../../services/filter-handler.service';
import {BarChartOrientation, ChartCore} from '@easycomp/easy-charts/lib/definitions/enums';
import {CzechNumberFormatPipe} from '../pipes/czech-number-format.pipe';

@Component({
    selector: 'app-projetc-graphs',
    templateUrl: './projetc-graphs.component.html',
    styleUrls: ['./projetc-graphs.component.scss']
})
export class ProjetcGraphsComponent implements OnInit {

    endYearData = {
        data: [],
        groups: [],
        ready: false
    };
    sumData = {
        data: [],
        labels: ['Dotace', 'Spoluúčast'],
        colors: [{backgroundColor: ['#5C8FB6', '#bebcc0']}],
        ready: false
    };
    fieldSumData = {
        data: [],
        groups: [],
        ready: false
    };
    fieldCountData = {
        data: [],
        groups: [],
        ready: false
    };

    sumChartOptions = {
      core: ChartCore.JS,
      labelFunction: (sector, data) => {
        return this.fieldSumData.data[sector.index].label;
        // return this.fieldSumData.data[sector.index].label + ' - ' + this.czechNumberPipe.transform(
        //   this.fieldSumData.data[sector.index].value.toFixed(0)
        // )  + ' Kč';
      },
      legendPercentace: true
    };

    countChartOptions = {
      core: ChartCore.JS,
      labelFunction: (sector, data) => {
        return this.fieldCountData.data[sector.index].label;
        // return this.fieldCountData.data[sector.index].label + ': ' + this.czechNumberPipe.transform(
        //   this.fieldCountData.data[sector.index].value
        // );
      },
      legendPercentace: true
    };

    partCountChartOptions = {
      core: ChartCore.JS,
      orientation: BarChartOrientation.VERTICAL,
      labelFunction: (sector, data) => {
        return sector.label + ': ' + sector.value;
      },
      legendDisplay: false,
      legendPercentace: true
    };

    filters: any;
    projects: Array<any>;
    graphsData: {
        endYear: Array<any>,
        fieldSum: Array<any>,
        sum: {budget: number, grant: number, participation: number}};

    constructor(private filterHandlerService: FilterHandlerService,
                private itemsHttp: HttpItemsService,
                private czechNumberPipe: CzechNumberFormatPipe) {
    }

    ngOnInit() {

        /** CORE */
        // Přihlášní k signálu na přenačtení obsahu
        this.filterHandlerService.onReloadDataSignal().subscribe(() => {
            this.filters = this.filterHandlerService.getFilters();
            this.getProjects();
        });
        if (this.filters == null) { // Pokud je komponenta právě vytvořena, dotáhni si data
            this.filters = this.filterHandlerService.getFilters();
        }
        this.getProjects();

        /** CORE END */
    }

    /** CODE FUNC */

    private getProjects() {
        this.itemsHttp.getGraphsData(this.filters).subscribe((result) => {
            this.projects = result.body.raw;
            this.graphsData = result.body.graphs;
            this.prepareYearEndData();
            // this.prepareSumData();
            // this.prepareFieldSumData();
            this.prepareFieldSumData();
            this.prepareFieldCountData();
        });
    }

    /** CORE FUNC END */

    private prepareFieldSumData() {
        this.itemsHttp.getSumsByFieldsGraphData(this.filters).subscribe( result => {
            this.fieldSumData.data = [];
            const tempDataArr = [];
            result.body.forEach( (item, key) => {
              tempDataArr.push({
                label: item.name + ' (' + this.czechNumberPipe.transform(item.grant + item.budget) + ' Kč)',
                value: item.grant + item.budget,
                color: item.color,
                data: {optionId: item.fieldId}
              });
              this.fieldSumData.groups.push(item.name);
            });
            this.fieldSumData.data = tempDataArr;
            // this.fieldSumData.groups = [];
            // result.body.forEach( (item, key) => {
            //     const tempVals = [];
            //     for ( let i = 0; i <= result.body.length; i++) {
            //         tempVals.push({
            //             value: (i === key ? item.grant + item.budget : 0),
            //             data: null
            //         });
            //     }
            //     this.fieldSumData.data.push({
            //         label: item.name,
            //         values: tempVals,
            //         color: item.color
            //     });
            //     this.fieldSumData.groups.push(item.name);
            // });

            this.fieldSumData.ready = true;
        });
    }

    private prepareFieldCountData() {
        this.itemsHttp.getCountsByFieldsGraphData(this.filters).subscribe( result => {
            this.fieldCountData.groups = [];
            this.fieldCountData.data = [];
            result.body.forEach( (item, key) => {
                // const tempVals = [];
                // for ( let i = 0; i <= result.body.length; i++) {
                //     tempVals.push({
                //         value: (i === key ? item.count : 0),
                //         data: null
                //     });
                // }
                // this.fieldCountData.data.push({
                //     label: item.name,
                //     values: tempVals,
                //     color: item.color
                // });
                //
                // this.fieldCountData.groups.push(item.name);
                this.fieldCountData.data.push({
                  label: item.name + ' (' + item.count + ')',
                  value: item.count,
                  color: item.color,
                  data: {optionId: item.fieldId}
                });
                this.fieldCountData.groups.push(item.name);
            });

            this.fieldCountData.ready = true;
        });
    }

    prepareYearEndData() {
        this.endYearData.ready = false;
        this.itemsHttp.getEndYearCountGraphData(this.filters).subscribe( result => {
            this.endYearData.groups = [];
            this.endYearData.data = [];
            const colors = [];
            const values = [];
            result.body.forEach( (item, key) => {
              colors.push('#' + Math.floor(Math.random() * 16777215).toString(16));
              values.push(item.count);
              this.endYearData.groups.push(item.name);
            });
            this.endYearData.data.push(
              {label: 'Městké části', values, color: colors }
            );
            // result.body.forEach((item, key) => {
            //     const tempVals = [];
            //     for ( let i = 0; i <= result.body.length; i++) {
            //         tempVals.push({
            //             value: (i === key ? item.count : 0),
            //             data: null
            //         });
            //     }
            //     this.endYearData.data.push({
            //         label: item.name,
            //         values: tempVals,
            //         color: '#' + Math.floor(Math.random() * 16777215).toString(16)
            //     });
            //
            //     this.endYearData.groups.push(item.name);
            // });
            console.log(this.endYearData.data);

            this.endYearData.ready = true;
        });
    }
    //
    // prepareSumData() {
    //     this.sumData.ready = false;
    //     this.sumData.data = [
    //         {label: 'Dotace', value: this.graphsData.sum.grant, color: '#386641'},
    //         {label: 'Spoluúčast', value: this.graphsData.sum.participation, color: '#6A994E'}
    //     ];
    //     this.sumData.ready = true;
    // }
    //
    // prepareFieldSumData() {
    //     this.fieldSumData.ready = false;
    //     this.fieldSumData.data = [];
    //     this.fieldSumData.labels = [];
    //     this.graphsData.fieldSum.forEach( (item) => {
    //
    //         this.fieldSumData.data.push({
    //                 values: [{
    //                     value: item.budget
    //                 }],
    //                 label: item.name,
    //                 color: item.color
    //             });
    //         // this.fieldSumData.colors.push({backgroundColor: item.color});
    //     });
    //     this.fieldSumData.labels.push('Celkem');
    //     this.fieldSumData.ready = true;
    // }
}
